import { Injectable, inject } from '@angular/core';
import { NoteBoxAnchor, NoteBoxVersion } from 'src/models/anchor-and-version/note-box.model';
import { AnchorAndVersionBaseService } from './anchor-and-version-base.service';
import { AuthService } from '../auth.service';
import { ConfigState } from 'src/store/reducers/config.reducer';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class NoteBoxService extends AnchorAndVersionBaseService<NoteBoxAnchor, NoteBoxVersion> {
    protected authService = inject(AuthService);
    protected baseUrl = '/api/notebox';
    protected http = inject(HttpClient);
    protected store = inject<Store<{ config: ConfigState }>>(Store);
}
